"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageBasedChargeNameToServiceDiscountTypes = exports.UnitBasedChargeNameToServiceDiscountTypes = exports.BaseChargeName = exports.SurchargeName = void 0;
const PriceResponse_1 = require("./PriceResponse");
var SurchargeName;
(function (SurchargeName) {
    SurchargeName["PACKAGING"] = "Packaging";
    SurchargeName["HAZARDOUS_MATERIALS"] = "Hazardous Materials";
    SurchargeName["PEAK"] = "Peak";
    SurchargeName["OVER_DIMENSIONAL"] = "Over Dimensional";
    SurchargeName["ADDITIONAL_PICK"] = "Additional Pick";
    SurchargeName["SIOC_NON_COMPLIANCE"] = "SIOC Non Compliance";
    SurchargeName["MARKETPLACE_CARRIER_RESTRICTION_SURCHARGE"] = "Marketplace Carrier Restriction";
    SurchargeName["DROPSHIPPING_ADDITIONAL_PICK"] = "Dropshipping Additional Pick";
    SurchargeName["DROPSHIPPING_LABEL_FEE"] = "Dropshipping Label Fee";
})(SurchargeName = exports.SurchargeName || (exports.SurchargeName = {}));
var BaseChargeName;
(function (BaseChargeName) {
    BaseChargeName["UNIT_FULFILLMENT"] = "Unit Fulfillment";
    BaseChargeName["PACKAGE_FULFILLMENT"] = "Package Fulfillment";
    BaseChargeName["DROPSHIPPING_BASE_CHARGE"] = "Dropshipping Base Charge";
})(BaseChargeName = exports.BaseChargeName || (exports.BaseChargeName = {}));
exports.UnitBasedChargeNameToServiceDiscountTypes = {
    [BaseChargeName.UNIT_FULFILLMENT]: [
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT,
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_OUTBOUND_VOLUME_BASED_DISCOUNT,
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_V2,
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_OUTBOUND_VOLUME_BASED_DISCOUNT_V2,
    ],
    [SurchargeName.PACKAGING]: [
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT,
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_OUTBOUND_VOLUME_BASED_DISCOUNT,
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_PACKAGING_DISCOUNT,
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_VOLUME_BASED_PACKAGING_DISCOUNT,
    ],
    [SurchargeName.HAZARDOUS_MATERIALS]: [
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT,
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_OUTBOUND_VOLUME_BASED_DISCOUNT,
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_HAZARDOUS_MATERIALS_DISCOUNT,
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_VOLUME_BASED_HAZARDOUS_MATERIALS_DISCOUNT,
    ],
    [SurchargeName.OVER_DIMENSIONAL]: [
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT,
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_OUTBOUND_VOLUME_BASED_DISCOUNT,
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_OVER_DIMENSIONAL_DISCOUNT,
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_VOLUME_BASED_OVER_DIMENSIONAL_DISCOUNT,
    ],
    [SurchargeName.MARKETPLACE_CARRIER_RESTRICTION_SURCHARGE]: [
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_MARKETPLACE_CARRIER_RESTRICTION_SURCHARGE,
    ],
    [SurchargeName.SIOC_NON_COMPLIANCE]: [
        PriceResponse_1.ServiceDiscountType.UNIT_FULFILLMENT_SIOC_NC_DISCOUNT,
    ],
    [SurchargeName.DROPSHIPPING_ADDITIONAL_PICK]: [
        PriceResponse_1.ServiceDiscountType.DROPSHIPPING_ADDITIONAL_PICK_SURCHARGE,
    ],
    [SurchargeName.DROPSHIPPING_LABEL_FEE]: [
        PriceResponse_1.ServiceDiscountType.DROPSHIPPING_LABEL_FEE,
    ],
};
exports.PackageBasedChargeNameToServiceDiscountTypes = {
    [BaseChargeName.PACKAGE_FULFILLMENT]: [
        PriceResponse_1.ServiceDiscountType.PACKAGE_FULFILLMENT,
    ],
    [BaseChargeName.DROPSHIPPING_BASE_CHARGE]: [
        PriceResponse_1.ServiceDiscountType.DROPSHIPPING_BASE_CHARGE,
    ],
    [SurchargeName.ADDITIONAL_PICK]: [
        PriceResponse_1.ServiceDiscountType.PACKAGE_FULFILLMENT_ADDITIONAL_UNIT_PICK_SURCHARGE_DISCOUNT,
    ],
    [SurchargeName.PEAK]: [],
    [SurchargeName.PACKAGING]: [
        PriceResponse_1.ServiceDiscountType.PACKAGE_FULFILLMENT_PACKAGING_DISCOUNT,
    ],
    [SurchargeName.OVER_DIMENSIONAL]: [
        PriceResponse_1.ServiceDiscountType.PACKAGE_FULFILLMENT_OVER_DIMENSIONAL_DISCOUNT,
    ],
    [SurchargeName.MARKETPLACE_CARRIER_RESTRICTION_SURCHARGE]: [
        PriceResponse_1.ServiceDiscountType.PACKAGE_FULFILLMENT_MARKETPLACE_CARRIER_RESTRICTION_SURCHARGE,
    ],
    [SurchargeName.HAZARDOUS_MATERIALS]: [
        PriceResponse_1.ServiceDiscountType.PACKAGE_FULFILLMENT_HAZARDOUS_MATERIALS_DISCOUNT,
    ],
    [SurchargeName.DROPSHIPPING_ADDITIONAL_PICK]: [
        PriceResponse_1.ServiceDiscountType.DROPSHIPPING_ADDITIONAL_PICK_SURCHARGE,
    ],
    [SurchargeName.DROPSHIPPING_LABEL_FEE]: [
        PriceResponse_1.ServiceDiscountType.DROPSHIPPING_LABEL_FEE,
    ],
    [SurchargeName.SIOC_NON_COMPLIANCE]: [
        PriceResponse_1.ServiceDiscountType.PACKAGE_FULFILLMENT_SIOC_NC_DISCOUNT,
    ],
};
//# sourceMappingURL=ItemizedPrice.js.map